import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Seo from "../../Seo/Seo";
import { webPageSchema } from "../../Seo/jsonld";
import { getRouteSeo } from "../../Seo/routeSeo";

const About = () => {
  // Removed the 1s `setTimeout` loader gate: it kept this page's content out
  // of the prerendered HTML, and `[loader]` made the effect re-arm endlessly.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const seo = getRouteSeo("/about");

  return (
    <React.Fragment>
      <main>
        <Seo
          type="article"
          jsonLd={[
            webPageSchema({
              title: seo?.title,
              description: seo?.description,
              url: "/about",
            }),
          ]}
        />
        <section className="page-info-sec">
          <div
            className="bg-fixed wow fadeIn"
            data-wow-delay="0.1s"
            style={{ background: 'url("/assets/img/page-info1.png")' }}
          />
          <div
            className="bg-fixed img-overlay wow fadeIn"
            data-wow-delay="0.2s"
          />
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div
                  className="page-info-block wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <h1>Om OS</h1>
                  <div className="btm-line-2 text-center justify-content-center">
                    <span />
                    <span />
                  </div>
                  <p>
                    Vi er en virksomhed, der konstant arbejder på at forbedre maden og gøre det så nemt for jer som forældre at bruge siden og få en god solid frokost til jeres børn.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sec-pd rel-z-1">
          <div className="top-bottom-shaps">
            <span className="shap shap-1" />
            <span className="shap shap-2" />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mmb-20">
                <div className="img-style-1 wow fadeInLeft">
                  <img src="/assets/img/about-1.png" alt="Frisklavet skolemad klar til levering" />
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <div
                    className="title-1 wow fadeInRight"
                    data-wow-delay="0.1s"
                    style={{
                      visibility: "visible",
                      animationDelay: "0.1s",
                      animationName: "fadeInUp",
                    }}
                  >
                    <h2 className="title-1-h">Vores vision</h2>
                    <div className="btm-line-1">
                      <span />
                      <span />
                    </div>
                    <p>

                    </p>
                    <div className="mt-3">
                      {/* <h2>Our Vision</h2> */}
                      <p>
                        Jeg startede med et pizzeria helt tilbage i 1993, men I 2011 besluttede jeg at begynde at levere skolemad. Jeg har selv børn, de er store nu, men de havde ikke kantinemad på deres skole, og det syntes jeg var ærgerligt, da vi ikke altid har tid til at pakke madpakkerne til børnene. Så jeg besluttede mig for at lave skolemad, med nogle retter, der ikke er helt så kedelige, og som børnene kan lide, og samtidig have noget sundt i sig.
                      </p>
                      <ul>
                        <li>Hurtige leveringstjenester</li>
                        <li>Vi sikrer vores madkvalitet</li>
                        <li>Mad tilberedt af en professionel kok</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="sec-pd bg-gray position-relative">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mmb-20">
                <div>
                  <div className="title-1 wow fadeInUp" data-wow-delay="0.1s">
                    <h2>Prøv Appen - Download Herunder <img src="/assets/img/heademoji.png" alt="" aria-hidden="true" style={{ height: '50px' }} /></h2>
                    <div className="btm-line-1">
                      <span />
                      <span />
                    </div>
                    <p>
                      Vi bruger app mere og mere nutildags, Appen vil gøre det
                      nemmere at bestille, bedre notifikationer. Bedre
                      muligheder får at høre jeres meninger, såsom bedre retter,
                      bedre brugervenlighed, og andre ideer.
                    </p>
                    <div className="flex-group play-app">
                      <Link className="btn btn-dark google_ply" target="blank" to={'https://apps.apple.com/dk/app/onlineskolemad/id6741146828?l=da'}>
                        <span className="play_img">
                          <img src="/assets/img/apple-icon.svg" alt="Apple App Store" />
                        </span>
                        <div className="download-cont">
                          <span>Download i</span>
                          <p>Appstore</p>
                        </div>
                      </Link>
                      <Link className="btn btn-dark google_ply" target="blank" to={'http://play.google.com/store/apps/details?id=com.onlineskolemad&hl=en'}>
                        <span className="play_img">
                          <img src="/assets/img/palystore-icon.svg" alt="Google Play" />
                        </span>
                        <div className="download-cont">
                          <span>Hent den i</span>
                          <p>Google Play</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="img-style-3 pl-2per img-res-md wow fadeInRight">
                  <img src="/assets/img/download-mobile.png" alt="Onlineskolemad-appen på en mobiltelefon" />
                </div>
              </div>
            </div>
          </div>
          <div className="download-banner img-res-md">
            <img src="/assets/img/download-app.png" alt="Download Onlineskolemad-appen" />
          </div>
        </section>
        {/* as a task client says to comment this line */}
        {/* <section className="sec-pd rel-z-1">
          <div className="top-bottom-shaps">
            <span className="shap shap-1" />
            <span className="shap shap-2" />
          </div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6 mmb-20">
                <div>
                  <div className="title-1 wow fadeInUp" data-wow-delay="0.1s">
                    <h1>Our Mission</h1>
                    <div className="btm-line-1">
                      <span />
                      <span />
                    </div>
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Nullam vel malesuada nisi. Donec suscipit varius risus,
                      non luctus nisl euismod sit amet. Quisque vitae metus ac
                      odio porttitor laoreet. Mauris a egestas est. Phasellus
                      nibh magna, auctor non magna vitae, aliquet malesuada
                      mauris. Sed gravida arcu et velit placerat volutpat.
                    </p>
                    <p>
                      Duis ac turpis. Integer rutrum ante eu lacus. Vestibulum
                      libero nisl, porta vel, scelerisque eget, malesuada at,
                      neque. Vivamus eget nibh. Pretium viverra suspendisse
                      potenti nullam ac tortor vitae purus. Habitant morbi
                      tristique senectus et netus et malesuada fames ac. t.
                      Nullam vel malesuada nisi. Donec suscipit varius risus,
                      non luctus nisl euismod sit amet. Quisque vitae metus ac
                      odio porttitor laoreet. Mauris a egestas est. Phasellus
                      nibh magna, auctor non magna vitae, aliquet uada mauris.
                      Sed gravida arcu et velit placerat volutpat.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="pl-10per wow fadeInRight">
                  <img
                    src="/assets/img/childrens-3.png"
                    className="img-fluid"
                    alt="Not found"
                  />
                </div>
              </div>
            </div>
          </div>
        </section> */}
        {/* <Slider /> */}
      </main>
    </React.Fragment>
  );
};

export default About;
